<h1 mat-dialog-title>از حذف این مورد اطمینان دارید؟</h1>
<div mat-dialog-actions>
  <button mat-raised-button color="warn" mat-dialog-close="delete">بله</button>
  <button mat-raised-button cdkFocusInitial mat-dialog-close>خیر</button>
</div>
